import React, { useState } from "react";
import Button from "./Button";
import { DateTime } from "luxon";
import { useStateContext } from "../contexts/ContextProvider";
import { apiCreatePublishedRoom } from "../services/apiService";

const initialErrorState = {
  available: "",
  terms: "",
};

const PublishRoomModal = (props) => {
  const { room, handleRoomUpdate } = props;
  const { handleModal, publishedRooms, setPublishedRooms, setUser } =
    useStateContext();
  const [roomToPublish, setRoomToPublish] = useState(room);
  const [terms, setTerms] = useState(false);
  const [error, setError] = useState(initialErrorState);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setRoomToPublish((prevState) => ({ ...prevState, [name]: value }));
  };

  const handlePublish = () => {
    if (hasErrors()) {
      return;
    } else {
      roomToPublish.isPublished = true;
      roomToPublish.roomUuid = room.uuid;
      handleRoomUpdate(roomToPublish);
      handlePublishRoom(roomToPublish);
      handleModal("publishRoom");
    }
  };

  const handlePublishRoom = async (room) => {
    const response = await apiCreatePublishedRoom(room);
    if (response.hasError) {
      console.log("Publish Room Error!");
      console.log(response.error.response.statusText);
      return;
    } else {
      setPublishedRooms((prevState) => [...prevState, response.data]);
      setUser((prevState) => ({ ...prevState, hasPublished: true }));
    }
  };

  const hasErrors = () => {
    if (!roomToPublish.available) {
      activateError("available");
      return true;
    }
    if (!terms) {
      activateError("terms");
      return true;
    } else {
      return false;
    }
  };

  const activateError = (item) => {
    setError((prevState) => ({
      ...prevState,
      [item]: "animate-shake text-red-600 border-red-600",
    }));
    setTimeout(() => {
      setError((prevState) => ({
        ...prevState,
        [item]: "",
      }));
    }, 500);
    clearTimeout();
  };

  return (
    <div className="w-screen h-screen fixed top-0 left-0 right-0 bg-white mt-20 z-10">
      <form className="grid justify-items-center">
        <div className={`flex justify-center mt-5 px-5 ${error.available}`}>
          What date will this room be available?
          <span className="text-red-500">*</span>
        </div>
        <label className="grid mt-5">
          <input
            id="available"
            name="available"
            type="date"
            min={DateTime.now().toFormat("yyyy-MM-dd")}
            value={roomToPublish.available || ""}
            className={`border-gray-300 border-1 rounded-md pl-1${error.available}`}
            onChange={handleChange}
          />
        </label>
        <div className="flex justify-center items-start px-20 mt-10">
          <input
            id="tou"
            name="tou"
            type="checkbox"
            checked={terms}
            onChange={() => setTerms(!terms)}
            className="h-4 w-4 mt-1 mr-2"
          />
          <div className={`${error.terms} text-justify text-pretty`}>
            <span onClick={() => setTerms(!terms)}>
              By publishing this room, I understand and agree to Snappily's{" "}
            </span>
            <span
              className="text-blue-500 hover:text-blue-700 underline cursor-pointer"
              onClick={() => console.log("terms of use")}
            >
              terms of use
            </span>
            .
          </div>
        </div>
      </form>
      <div className="flex justify-center fixed bottom-0 w-full my-10">
        <Button
          background="bg-slate-400"
          text="text-white"
          opacity="bg-opacity-100"
          title={"Close"}
          height="h-10"
          width="w-24"
          borderColor="border-none"
          borderHover="hover:border-snappily-orange"
          customFunc={() => handleModal("publishRoom")}
        />
        <Button
          background="bg-snappily-orange"
          text="text-white"
          opacity="bg-opacity-100"
          title={"Publish"}
          height="h-10"
          width="w-24"
          borderColor="border-none"
          borderHover="hover:border-snappily-orange"
          customFunc={handlePublish}
        />
      </div>
    </div>
  );
};

export default PublishRoomModal;
